export enum REPORT_STATUS_ENUM {
  PROCESSING = 'processing',
  DONE = 'done',
  ERROR = 'error',
}
